import React from 'react';

const Loading = () => <div className="spinner" />;

export default Loading;
